import React from 'react';

const IconItaly = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 90.77 63.15"
      {...props}
    >
      <g fillRule="nonzero">
        <path
          fill="#009246"
          d="M29.47 0v63.15H4.99C2.24 63.15 0 60.9 0 58.16V4.99C0 2.24 2.24 0 4.99 0h24.48z"
        />
        <path fill="#fff" d="M61.31 0v63.15H29.47V0z" />
        <path
          fill="#CE2B37"
          d="M61.31 63.15V0h24.48c2.74 0 4.98 2.24 4.98 4.99v53.17c0 2.74-2.24 4.99-4.98 4.99H61.31z"
        />
      </g>
    </svg>
  );
};

export default IconItaly;
